import { useEffect, useState } from 'react';
import apiClient from '../../utils/api-client';
import getColumnClass from '../../utils/getColumnClass';
import CardSkeleton from '../Common/CardSkeleton';
import GridControls from '../Common/GridControls';
import ProductCard from '../Shop/ProductCard';
const YouMayAlsoLikeProducts = () => {
  const [randomProducts, setRandomProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
  const [gridSize, setGridSize] = useState(() => {
    const storeGridZize = localStorage.getItem('ProductsGridSize');
    return storeGridZize ? parseInt(storeGridZize, 10) : 4;
  });
  useEffect(() => {
    localStorage.setItem('ProductsGridSize', gridSize.toString());
  }, [gridSize]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    fetchRandomProducts(page);
  }, [page]);
  const fetchRandomProducts = async (currentPage) => {
    try {
      setIsFetching(true);
      const response = await apiClient.post('/products', { page: currentPage });
      const { data, total_pages } = response.data;
      setRandomProducts((prevProducts) => {
        const uniqueNewProducts = data.filter(
          (newProduct) =>
            !prevProducts.some(
              (product) => product.product_id === newProduct.product_id
            )
        );
        return [...prevProducts, ...uniqueNewProducts];
      });
      setTotalPages(total_pages);
      setIsLoading(false);
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
    } finally {
      setIsFetching(false);
    }
  };
  const loadMoreProducts = () => {
    if (page <= totalPages && !isFetching) {
      setPage((prevPage) => prevPage + 1);
    }
  };
  return (
    <section className="random_product_section">
      <div className="container-fluid">
        <div className="col-12">
          <div className="categories_title text-center">
            <h2>You May Also Like</h2>
            <hr className="featured_underline mb-2" />
          </div>
          <div className="random_product_text">
            <p>
              Shop reliable, everyday products from the best online store —
              easy, affordable, and trusted.
            </p>
          </div>
        </div>

        <GridControls
          gridSize={gridSize}
          setGridSize={setGridSize}
          windowWidth={windowWidth}
        />

        <div className="row">
          {error && <em className="form_error">{error}</em>}
          {isLoading && <CardSkeleton cards={8} />}
          {randomProducts &&
            randomProducts.map((product) => (
              <div
                key={product.product_id}
                className={`${getColumnClass(gridSize, windowWidth)} p-2`}
              >
                <ProductCard key={product.product_id} product={product} />
              </div>
            ))}
        </div>
        {page < totalPages && (
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <button
                className="btn "
                style={{ backgroundColor: '#800180', color: 'white' }}
                onClick={loadMoreProducts}
                disabled={isFetching}
              >
                {isFetching ? 'Loading...' : 'Load More'}
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
export default YouMayAlsoLikeProducts;
